// src/hooks/useBrowserMonitoring.ts
import * as Sentry from "@sentry/react";

import C from "../constants/constants";

const initializeSentry = () => {
  // Only initialize Sentry in production/staging environments
  if (C.SENTRY_ENABLED_ENVIRONMENTS.includes(C.ENVIRONMENT)) {
    Sentry.init({
      dsn: C.VITE_SENTRY_DSN,
      environment: C.ENVIRONMENT,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      release: C.APP_VERSION,
      replaysOnErrorSampleRate: 1,
      replaysSessionSampleRate: 1,
      sendDefaultPii: true,
      tracesSampleRate: 1,
    });
  }
};

export { initializeSentry };
